import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import UpdateTenantModal from './update-modal'
import DeleteTenantModal from './delete-modal'

class TenantsTableRow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editing: false,
      deleting: false
    }

    this.handleUpdateModalClosed = this.handleUpdateModalClosed.bind(this)
    this.handleDeleteModalClosed = this.handleDeleteModalClosed.bind(this)
    this.showEditModal = this.showEditModal.bind(this)
    this.showDeleteModal = this.showDeleteModal.bind(this)
  }

  handleUpdateModalClosed () {
    this.setState({ editing: false })
    this.props.onUpdated()
  }

  handleDeleteModalClosed () {
    this.setState({ deleting: false })
    this.props.onUpdated()
  }

  showEditModal () {
    this.setState({ editing: true })
  }

  showDeleteModal () {
    this.setState({ deleting: true })
  }

  render () {
    const { editing, deleting } = this.state
    const { id, name, createdAt } = this.props

    return (
      <tr>
        <td className='text-left'>{name}</td>
        <td className='text-left'>
          {createdAt ? (
            /* istanbul ignore next */ window
              .moment(createdAt)
              .format()
              .replace('T', ' ')
              .slice(0, 16)
          ) : (
            'No created date'
          )}
        </td>
        <td className='width-fifteen'>
          <Link
            to={`/admin/permissions/tenant/${id}`}
            className='btn btn-sm blue-sharp padding-adjust'
          >
            <i className='fa fa-users' />
          </Link>
          <button
            className='btn btn-sm green padding-adjust'
            onClick={this.showEditModal}
          >
            <i className='fa fa-edit' />
          </button>
          <button
            className='btn btn-sm red padding-adjust'
            onClick={this.showDeleteModal}
          >
            <i className='fa fa-trash margin-right-1' />
          </button>
        </td>
        <UpdateTenantModal
          id={id}
          name={name}
          show={editing}
          onClose={this.handleUpdateModalClosed}
        />
        <DeleteTenantModal
          id={id}
          name={name}
          show={deleting}
          onClose={this.handleDeleteModalClosed}
        />
      </tr>
    )
  }
}

TenantsTableRow.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  createdAt: PropTypes.number.isRequired,
  onUpdated: PropTypes.func
}

export default TenantsTableRow



// WEBPACK FOOTER //
// ./src/pages/admin/tenants/tenants-table-row.js